module.exports = __webpack_public_path__ + "img/kitchen.ab260006.png";